import { render, staticRenderFns } from "./CompositionList.vue?vue&type=template&id=5e6e4a5c&scoped=true"
import script from "./CompositionList.vue?vue&type=script&lang=js"
export * from "./CompositionList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e6e4a5c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/ap/jenkins/workspace/prod-ykd360-admin-front(医可达旧管理端)/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5e6e4a5c')) {
      api.createRecord('5e6e4a5c', component.options)
    } else {
      api.reload('5e6e4a5c', component.options)
    }
    module.hot.accept("./CompositionList.vue?vue&type=template&id=5e6e4a5c&scoped=true", function () {
      api.rerender('5e6e4a5c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/treatment/composition/CompositionList.vue"
export default component.exports